export const getLaunchToken = () => /* GraphQL */ `
  query GetLaunchToken($input: ModelGetInput!) {
    getLaunchToken(input: $input) {
      id
      sk
      token
    }
  }
`;
